import { render, staticRenderFns } from "./s2-1.vue?vue&type=template&id=9a5bdba6&scoped=true&"
import script from "./s2-1.vue?vue&type=script&lang=js&"
export * from "./s2-1.vue?vue&type=script&lang=js&"
import style0 from "./s2-1.vue?vue&type=style&index=0&id=9a5bdba6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a5bdba6",
  null
  
)

export default component.exports